import {e2p} from "../bootstrap/components/extensions";

const LoanApp = function (config, $) {
    const app = this;

    app.elms = {};
    app.elms.$wrap = $(config.wrapId);
    app.elms.range = document.querySelector(".loan__slider");
    app.elms.$earn = app.elms.$wrap.find(".loan__earn");
    app.elms.$order = app.elms.$wrap.find(".loan__order");

    const events = new function () {
        this.bind = function () {
            app.elms.range.addEventListener('input', rangeSliderChanged);
        }
    }

    const rangeSliderChanged = function () {

        switch (this.value) {
            case '1':
            case '0':
                app.elms.$earn.html(e2p(10));
                app.elms.$order.html(e2p(1));
                break;
            case '5':
                app.elms.$earn.html(e2p(20));
                app.elms.$order.html(e2p(5));
                break;
            case '10':
                app.elms.$earn.html(e2p(30));
                app.elms.$order.html(e2p(10));
                break;
            case '15':
                app.elms.$earn.html(e2p(40));
                app.elms.$order.html(e2p(15));
                break;
            case '20':
                app.elms.$earn.html(e2p(50));
                app.elms.$order.html(e2p(20));
                break;
        }
    }

    app.init = function () {

        events.bind();

        return this;
    }
}

new LoanApp({wrapId: '.loan'}, jQuery).init();